export const DEFAULT_THEME = 'light';
export const THEME_STORAGE_KEY = 'oyb-theme';

export const THEME_EVENTS = {
  changed: 'oyb-theme-changed',
} as const;

export type ThemeMode = 'light' | 'dark';

export function isThemeMode(value: string | null): value is ThemeMode {
  return value === 'light' || value === 'dark';
}
